/** @format */

import {roundFloatNumber, safeDivide} from 'helpers/numberHelpers';

import {GraphStatFromQuery} from '../../models/api';
import {GraphStat} from '../../models/common';
import {EXCLUDED_EXTENDED_PLATFORMS} from '../../constants/common';
import {PartialGraphStatList} from './types';

const collectGraphStats = (graphStats: ReadonlyArray<GraphStatFromQuery>): PartialGraphStatList => {
  const result: PartialGraphStatList = {};

  graphStats
    .filter(graph => !EXCLUDED_EXTENDED_PLATFORMS.includes(graph.extendedPlatform))
    .forEach(graph => {
      const {date, clicks, spent, impressions} = graph;
      const newData: Partial<GraphStat> = {
        date,
        budget: spent,
        shows: impressions,
        clicks,
        cpc: roundFloatNumber(safeDivide(spent, clicks), 1),
        ctr: roundFloatNumber(safeDivide(clicks, impressions) * 100, 1),
      };

      if (result[date]) {
        const collected = result[date];
        const newBudget = (collected.budget ?? 0) + (newData.budget ?? 0);
        const newShows = (collected.shows ?? 0) + (newData.shows ?? 0);
        const newClicks = (collected.clicks ?? 0) + (newData.clicks ?? 0);
        result[date] = {
          date,
          budget: newBudget,
          shows: newShows,
          clicks: newClicks,
          cpc: roundFloatNumber(safeDivide(newBudget, newClicks), 1),
          ctr: roundFloatNumber(safeDivide(newClicks, newShows) * 100, 1),
        };
      } else {
        result[date] = newData;
      }
    });

  return result;
};

export {collectGraphStats};
